// Quotation Internal Review Stage related codes goes here

// NPM Imports
import React, { Fragment } from "react";

// Components Imports
import { QuotationInternalStageBtns } from "../QuotationTopBarBtns";

// Declarations

export default function QuotationInternalStage(props) {
  return (
    <Fragment>
      <div className="document-meta">
        <div
          data-test="quotationtopbarbtns-document-meta"
          className="document-btns">
          <QuotationInternalStageBtns {...props} />
        </div>
      </div>
    </Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/QuotationTopBarV2/QuotationStages/QuotationInternalStage.js